export default __webpack_public_path__ + "static/media/Snd_ClowerL.da40af4d.mp3";